import Alert from '@mui/material/Alert'
import { Theme } from '@mui/material/styles'
import * as React from 'react'

export function Fail() {
  return (
    <Alert
      severity="error"
      sx={{ marginTop: (theme: Theme) => theme.spacing(1) }}
    >
      Failed to retrieve search results. Please try again.
    </Alert>
  )
}
